module.exports = __webpack_public_path__ + "img/finland-genitourinary-diseases-male.2d054343.png";